import useGTM from "./useGTM";

export default useGTM;
